<template>
  <div class="menu-container">
    <template v-for="v in menuList">
      <el-submenu
        :index="v.englishName"
        v-if="v.children && v.children.length > 0"
        :key="v.englishName"
      >
        <template slot="title">
          <i
            v-if="v.englishName === 'notice'"
            class="el-icon-message-solid noticeIcon"
          ></i>
          <i v-else :class="'iconfont icon-' + v.englishName"></i>
          <span>{{ v.name }}</span>
        </template>
        <my-nav :menuList="v.children"></my-nav>
      </el-submenu>
      <el-menu-item
        :key="v.englishName"
        :index="v.englishName"
        @click="gotoRoute(v.englishName)"
        v-else
      >
        <i :class="'iconfont icon-' + v.englishName"></i>
        <span slot="title">{{ v.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import { title } from "@/common/util.js";

export default {
  name: "my-nav",
  props: {
    menuList: {
      type: Array,
      default: [],
    },
  },
  methods: {
    gotoRoute(name) {
      this.$router.push({ name });
      title(this.$route.meta.title);
    },
  },
};
</script>
<style lang="scss">
.menu-container {
  .noticeIcon {
    font-size: 20px;
    margin-right: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OAMenu/components/myNav.vue